module.exports = __webpack_public_path__ + "img/sumary_ev_charger.dc51885a.svg";